import { Grid, Typography } from '@mui/material';
import type { GanadoEnCorral } from '../../api-client/ganado/ganado';

interface EncabezadoDialogProps {
  animal: GanadoEnCorral
}

const EncabezadoDialogo = ({ animal }: EncabezadoDialogProps) => {
  return (
    <>
      <Grid size={6}>
        <Typography>TIPO GANADO:</Typography>
      </Grid>
      <Grid size={6}>
        <Typography>{animal.tipoGanado}</Typography>
      </Grid>
      <Grid size={6}>
        <Typography>ARETE TEMPORAL:</Typography>
      </Grid>
      <Grid size={6}>
        <Typography>{animal.areteTemporal?.replace(/([a-zA-Z]{1})([0-9]{1,3})/, '$1-$2')}</Typography>
      </Grid>
      <Grid size={6}>
        <Typography>ARETE SIINIGA:</Typography>
      </Grid>
      <Grid size={6}>
        <Typography>{animal.areteSiiniga?.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3')}</Typography>
      </Grid>
    </>
  );
};

export default EncabezadoDialogo;
